declare global {
  interface Window {
    __APP_CONFIG__?: Record<string, string | undefined>;
  }
}

// Build-time fallback: Vite statically replaces each process.env.REACT_APP_*
// reference with the .env value at build time. This serves local dev where
// public/config.js has empty values.
const buildTimeFallback: Record<string, string | undefined> = {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_SERVER_WEBSOCKET_PROTOCOL: process.env.REACT_APP_SERVER_WEBSOCKET_PROTOCOL,
  REACT_APP_SERVER_HOSTNAME: process.env.REACT_APP_SERVER_HOSTNAME,
  REACT_APP_SERVER_PORT: process.env.REACT_APP_SERVER_PORT,
  REACT_APP_WINDSCREEN_WEBSOCKET_PROTOCOL: process.env.REACT_APP_WINDSCREEN_WEBSOCKET_PROTOCOL,
  REACT_APP_WINDSCREEN_HOSTNAME: process.env.REACT_APP_WINDSCREEN_HOSTNAME,
  REACT_APP_WINDSCREEN_PORT: process.env.REACT_APP_WINDSCREEN_PORT,
  REACT_APP_MAPBOX_TOKEN: process.env.REACT_APP_MAPBOX_TOKEN,
  REACT_APP_MAP_STYLE: process.env.REACT_APP_MAP_STYLE,
  REACT_APP_CLERK_PUBLISHABLE_KEY: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,
  REACT_APP_USE_MQTT: process.env.REACT_APP_USE_MQTT,
  REACT_APP_MQTT_URL: process.env.REACT_APP_MQTT_URL,
  REACT_APP_MQTT_USERNAME: process.env.REACT_APP_MQTT_USERNAME,
  REACT_APP_MQTT_PASSWORD: process.env.REACT_APP_MQTT_PASSWORD,
  REACT_APP_DUAL_CREW_DRONE_1_UUID: process.env.REACT_APP_DUAL_CREW_DRONE_1_UUID,
  REACT_APP_DUAL_CREW_DRONE_2_UUID: process.env.REACT_APP_DUAL_CREW_DRONE_2_UUID,
  REACT_APP_DUAL_CREW_DRONE_1_CALLSIGN: process.env.REACT_APP_DUAL_CREW_DRONE_1_CALLSIGN,
  REACT_APP_DUAL_CREW_DRONE_2_CALLSIGN: process.env.REACT_APP_DUAL_CREW_DRONE_2_CALLSIGN,
  REACT_APP_DUAL_CREW_VIDEO_SERVER_URL: process.env.REACT_APP_DUAL_CREW_VIDEO_SERVER_URL,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
};

function get(key: string): string | undefined {
  // Runtime config (from config.js) takes precedence
  // eslint-disable-next-line no-underscore-dangle
  const runtimeVal = window.__APP_CONFIG__?.[key];
  if (runtimeVal) return runtimeVal;
  // Fall back to build-time env vars (for local dev)
  return buildTimeFallback[key];
}

export const config = {
  REACT_APP_ENV: get('REACT_APP_ENV'),
  REACT_APP_SERVER_WEBSOCKET_PROTOCOL: get('REACT_APP_SERVER_WEBSOCKET_PROTOCOL'),
  REACT_APP_SERVER_HOSTNAME: get('REACT_APP_SERVER_HOSTNAME'),
  REACT_APP_SERVER_PORT: get('REACT_APP_SERVER_PORT'),
  REACT_APP_WINDSCREEN_WEBSOCKET_PROTOCOL: get('REACT_APP_WINDSCREEN_WEBSOCKET_PROTOCOL'),
  REACT_APP_WINDSCREEN_HOSTNAME: get('REACT_APP_WINDSCREEN_HOSTNAME'),
  REACT_APP_WINDSCREEN_PORT: get('REACT_APP_WINDSCREEN_PORT'),
  REACT_APP_MAPBOX_TOKEN: get('REACT_APP_MAPBOX_TOKEN'),
  REACT_APP_MAP_STYLE: get('REACT_APP_MAP_STYLE'),
  REACT_APP_CLERK_PUBLISHABLE_KEY: get('REACT_APP_CLERK_PUBLISHABLE_KEY'),
  REACT_APP_USE_MQTT: get('REACT_APP_USE_MQTT'),
  REACT_APP_MQTT_URL: get('REACT_APP_MQTT_URL'),
  REACT_APP_MQTT_USERNAME: get('REACT_APP_MQTT_USERNAME'),
  REACT_APP_MQTT_PASSWORD: get('REACT_APP_MQTT_PASSWORD'),
  REACT_APP_DUAL_CREW_DRONE_1_UUID: get('REACT_APP_DUAL_CREW_DRONE_1_UUID'),
  REACT_APP_DUAL_CREW_DRONE_2_UUID: get('REACT_APP_DUAL_CREW_DRONE_2_UUID'),
  REACT_APP_DUAL_CREW_DRONE_1_CALLSIGN: get('REACT_APP_DUAL_CREW_DRONE_1_CALLSIGN'),
  REACT_APP_DUAL_CREW_DRONE_2_CALLSIGN: get('REACT_APP_DUAL_CREW_DRONE_2_CALLSIGN'),
  REACT_APP_DUAL_CREW_VIDEO_SERVER_URL: get('REACT_APP_DUAL_CREW_VIDEO_SERVER_URL'),
  REACT_APP_API_URL: get('REACT_APP_API_URL'),
};
